//**auto-generated don't edit this code**//
export enum StudentRace {
	Asian,
	BlackOrAfricanAmerican,
	Multiethnic,
	NativeAmericanOrAlaskaNative,
	NativeHawaiianOrPacificIslander,
	WhiteOrCaucasian,
	HispanicOrLatino,
	MiddleEasternOrNorthAfrican,
	Other,
}